
import { Component, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

// Composants
import { DialogBaseComponent } from 'src/app/@shared/components/abstract/dialog-base.component';

// Modèles
import { Conversation } from 'src/app/@shared/models/messaging/conversation.model';
import { ConversationsPanelComponent } from "../conversations-panel/conversations-panel.component";

@Component({
	selector: 'app-conversations-dialog',
	imports: [
    ConversationsPanelComponent
],
	templateUrl: './conversations-dialog.component.html',
	styleUrl: './conversations-dialog.component.scss'
})
export class ConversationsDialogComponent extends DialogBaseComponent {

	// Contexte
	public objectId: number;
	public entityType: string;
	/** Fil désigné par l'adresse, à afficher à l'ouverture (#995). */
	public initialConversationId: number | null;

	private _config = inject(DynamicDialogConfig);

	/*----------------------------------------------------------------------------------------
	 * Gestion de la vue
	 ----------------------------------------------------------------------------------------*/



	/*----------------------------------------------------------------------------------------
	 * Données
	 ----------------------------------------------------------------------------------------*/

	private _conversations: Conversation[] = [];
	public get conversations(): Conversation[] {
		return this._conversations;
	}
	public set conversations(value: Conversation[]) {
		let emptyArray: Conversation[] = [];
		this._conversations = emptyArray.concat(value);
	}

	/*----------------------------------------------------------------------------------------
	 * Accesseurs
	 ----------------------------------------------------------------------------------------*/



	/*----------------------------------------------------------------------------------------
	 * Méthodes publiques
	 ----------------------------------------------------------------------------------------*/

	constructor() {
		super();

		// Définition du chèque ou création d'un nouveau
		this.conversations = this._config.data.conversations;

		this.objectId = this._config.data.objectId;
		this.entityType = this._config.data.entityType;
		this.initialConversationId = this._config.data.initialConversationId ?? null;
	}

	/*----------------------------------------------------------------------------------------
	 * Méthodes protégées
	 ----------------------------------------------------------------------------------------*/

	/**
	 * Le volet fermé, plus aucun fil n'est affiché : l'adresse ne doit plus en désigner un (#995).
	 *
	 * Seul le fil part — la ligne, elle, reste désignée : c'est la fenêtre de détail qui la
	 * possède, et elle est toujours ouverte derrière ce volet.
	 *
	 * Une fermeture provoquée par une navigation ne passe pas ici : c'est la navigation qui
	 * décide alors de l'adresse.
	 */
	protected override afterUserClose(): void {
		this.setConversationInUrl(null);
	}

	/*----------------------------------------------------------------------------------------
	 * Méthodes privées
	 ----------------------------------------------------------------------------------------*/

}
